import {Breadcrumb, ButtonWithIcon, Tag} from '@/components/atoms'
import {OverViewSubHeader, PageHeader, TabsComponent} from '@/components/molecules'
import {BaseData, BrandAndCategory, MediaGallery, TaxAndSales} from '@/containers'
import {ProductDisplayBlock} from '@/containers/ProductDisplayBlock'
import {COLOR, TAG_COLOR} from '@/utils/constants/colors'
import {SIZE} from '@/utils/constants/globalStyle'
import {useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import './_productOverview.scss'
import {useProductOverview} from './useProductOverview'
import { ROUTES } from '@/utils/constants/routesConstants'

export const ProductReview = () => {
  const navigate = useNavigate()
  const {productOverviewData} = useProductOverview()
  const [activeTabIndex, setActiveTabIndex] = useState(0)

  const location = useLocation()
  const state = location?.state

  const productData = productOverviewData ?? {}
  const tabList = [
    {
      id: 'Base Data',
      tabLabel: 'Base Data',
      tabComponent: (
        <BaseData
          productData={{baseData: productData?.data?.baseData, additionalInfo: productData?.data?.additionalInfo}}
        />
      ),
    },
    {
      id: 'Media',
      tabLabel: 'Media',
      tabComponent: (
        <MediaGallery title={productData?.data?.baseData?.productId} productData={productData?.data?.media} />
      ),
    },
    {
      id: 'Display',
      tabLabel: 'Display',
      tabComponent: <ProductDisplayBlock productData={productData?.data?.display} />,
    },
    {
      id: 'Brand & Category',
      tabLabel: 'Brand & Category',
      tabComponent: (
        <BrandAndCategory
          productData={{brandInfo: productData?.data?.brandInfo, category: productData?.data?.category}}
        />
      ),
    },
    {
      id: 'Tax & Sales ',
      tabLabel: 'Tax & Sales ',
      tabComponent: (
        <TaxAndSales productData={{taxes: productData?.data?.taxes, saleUoms: productData?.data?.saleUoms}} />
      ),
    },
  ]

  const breadcrumbs = [
    {href: '/', label: ''},
    {href: ROUTES.PRODUCTS_LIST, label: 'Product view'},
    {href: '', label: productData?.data?.baseData?.name || 'Loading...'},
  ]
  return (
    <>
      <div className="productOverview">
        <Breadcrumb uiSchema={{isDark: true, className: 'mb-5', breadcrumbs}} id="productOverviewBreadcrumb" />
        <div className="header-wrapper flex items-center">
          <PageHeader title={productData?.data?.baseData?.name || 'Loading...'} />
          <div className="ml-6">
            {productData?.data?.baseData?.status && (
              <Tag
                color={
                  productData?.data?.baseData?.status.toLowerCase() === 'active'
                    ? TAG_COLOR.GREEN
                    : productData?.data?.baseData?.status.toLowerCase() === 'draft'
                      ? TAG_COLOR.BLUE
                      : TAG_COLOR.GRAY
                }
                text={productData?.data?.baseData?.status}
              />
            )}
          </div>
        </div>
        <OverViewSubHeader
          className="product-overview-sub-header"
          id={'product_overview_sub_header'}
          isIconHidden={true}
          items={[
            {label: 'Product ID', value: productData?.data?.baseData?.productId || '-'},
            {label: 'GTIN', value: productData?.data?.baseData?.gtin || '-'},
            {label: 'Parent ID', value: productData?.data?.baseData?.parentId || '-', copy: true},
          ]}
        />
        <div className="tabs-container">
          <ButtonWithIcon
            uiSchema={{
              className: 'ml-8 flex items-center text-sm text-[#0069D7] border-none',
              title: 'Edit',
              size: SIZE.SMALL,
              variant: COLOR.TERTIARY,
              isDark: true,
            }}
            iconLeading="edit"
            handleButton={() =>
              navigate(`/products/product/edit/${productData?.data?.baseData?.productId}`, {
                state: {
                  selectedTabNumb: activeTabIndex, // You can pass any data here
                },
              })
            }
          />
          <TabsComponent
            setTabIndex={setActiveTabIndex}
            key={productData?.id || 'tabs'}
            tabList={tabList}
            defaultTabIndex={state?.selectedTabNumb ?? 0}
            removeBG={true}
          />
        </div>
      </div>
    </>
  )
}

export default ProductReview
